export default "__VITE_ASSET__rVr$55Ai__"